(function ($) {
  var $headerSearchToggle = $(".header-search-btn"),
    $headerSearchWrap = $(".header-search-wrapper"),
    $headerSearchInput = $headerSearchWrap.find('input[type="text"]');

  // Handler for click show/hide button.
  $headerSearchToggle.on("click", function (event) {
    event.preventDefault();

    if ($(this).hasClass("open")) {
      hideSearch();
    } else {
      showSearch();
    }
  });

  // Handler for pressing show/hide button.
  $headerSearchToggle.on("keydown", function (event) {
    // If tabbing from toggle button, and search is hidden, exit early.
    if (9 === event.keyCode && !$headerSearchWrap.hasClass("search-visible")) {
      return;
    }

    event.preventDefault();
    handleKeyDown(event);
  });

  // Hide search when tabbing or escaping out of the search bar.
  $headerSearchInput.on("keydown", function (event) {
    // Tab: 9, Esc: 27.
    if (9 === event.keyCode || 27 === event.keyCode) {
      hideSearch(event.target);
    }
  });

  // Helper function to show the search form.
  function showSearch() {
    $headerSearchToggle.addClass("open").attr("aria-expanded", true);
    $headerSearchWrap.addClass("search-visible").fadeIn("fast");
    $headerSearchInput.focus();
  }

  // Helper function to hide the search form.
  function hideSearch() {
    $headerSearchToggle.removeClass("open").attr("aria-expanded", false);
    $headerSearchWrap.removeClass("search-visible").fadeOut("fast");
  }

  // Keydown handler function for toggling search field visibility.
  function handleKeyDown(event) {
    // Enter/Space, respectively.
    if (13 === event.keyCode || 32 === event.keyCode) {
      event.preventDefault();

      if ($(event.target).hasClass("open")) {
        hideSearch();
      } else {
        showSearch();
      }
    }
  }
})(jQuery);
